import * as React from "react";
import { usePatronStatus } from "@/api/fapinstructor/patreon/get-patreon-status";
import { hasRequiredMembership } from "@fapinstructor/common";
import { useNavigate } from "@tanstack/react-router";

type RedirectPatronsProps = {
  children: React.ReactNode;
};

export function RedirectPatrons({ children }: RedirectPatronsProps) {
  const navigate = useNavigate();

  const patronStatusQuery = usePatronStatus();

  React.useLayoutEffect(() => {
    if (
      patronStatusQuery.isSuccess &&
      hasRequiredMembership(patronStatusQuery.data.membershipTier, "follower")
    ) {
      navigate({ to: "/" });
    }
  }, [patronStatusQuery.isSuccess, patronStatusQuery.data, navigate]);

  return <>{children}</>;
}
